import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnDestroy,
  Output,
  SimpleChanges,
  inject,
} from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { PLATFORM_ID } from '@angular/core';
import * as am5 from '@amcharts/amcharts5';
import { ChartHostOverlayComponent } from '../chart-host-overlay/chart-host-overlay';

@Component({
  selector: 'app-chart-fullscreen-modal',
  imports: [ChartHostOverlayComponent],
  templateUrl: './chart-fullscreen-modal.html',
  styleUrl: './chart-fullscreen-modal.css',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ChartFullscreenModalComponent implements OnChanges, OnDestroy {
  @Input() visible = false;
  @Input() title = '';
  @Input() chartRenderer?: (host: HTMLDivElement) => am5.Root;
  @Input() refreshToken = 0;
  @Input() loading = false;
  @Output() visibleChange = new EventEmitter<boolean>();

  private platformId = inject(PLATFORM_ID);
  private chartRoot?: am5.Root;
  private chartHost?: HTMLDivElement;

  ngOnChanges(changes: SimpleChanges) {
    if (changes['visible']) {
      if (!this.visible) {
        this.chartHost = undefined;
        this.destroyChart();
      }
    }
    if (changes['refreshToken'] && !changes['refreshToken'].firstChange && this.visible && this.chartHost) {
      this.initChart();
    }
  }

  ngOnDestroy() {
    this.destroyChart();
  }

  onChartHostReady(host: HTMLDivElement) {
    this.chartHost = host;
    this.initChart();
  }

  close() {
    this.visibleChange.emit(false);
  }

  closeOnBackdrop(event: MouseEvent) {
    if (event.target === event.currentTarget) {
      this.close();
    }
  }

  private initChart() {
    if (!isPlatformBrowser(this.platformId) || !this.chartRenderer || !this.chartHost) return;
    this.destroyChart();
    this.chartRoot = this.chartRenderer(this.chartHost);
  }

  private destroyChart() {
    this.chartRoot?.dispose();
    this.chartRoot = undefined;
  }
}
